import { Navigate, Outlet } from 'react-router-dom';

const PriseenRoutesLayout = () => {
  // const token = localStorage.getItem('priseen_token'); // or sessionStorage

  // if (!token) {
  //   return (
  //     <div className="flex items-center justify-center h-full flex-col">
  //       <p className="text-md">Connect to Priseen to access these pages!</p>
  //       <p className="text-grey-600">Press the Connect to Priseen button in the navbar and refresh the page.</p>
  //     </div>
  //   );
  // }

  return <Outlet />;
};

export default PriseenRoutesLayout;
